import React from "react";
import {
  coresTextosGlobais, textosGlobais,
  iconesGlobais,
  espacamentosGlobais,
  tamanhosControlesGlobais,
  tamanhosPaginasAdministrativas,
} from "../../estilos/global";

import { Box, Button, Paper, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useMovimentoReduzido as useReducedMotion } from "../../contextos/PreferenciasContext";
import { obterTransicaoPaginaInicial } from "../../componentes/comuns/TransicaoPagina";

import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import { BuildingsFillIcon } from "../../componentes/ItemList";

import { useNavigate } from "react-router-dom";

const ESTILO_CAIXA_ICONE = {
  width: 48,
  height: 48,
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
  borderRadius: 1.5,
  color: "var(--sear-azul, #087cf0)",
  backgroundColor: "var(--sear-superficie-azul, #e8f4ff)",
};

const ESTILO_TITULO_SECAO = {
  color: coresTextosGlobais.tituloSecao,
  ...textosGlobais.tituloSecao,
  fontSize: tamanhosPaginasAdministrativas.tituloSecao,
  overflowWrap: "anywhere",
};

const ESTILO_DESCRICAO = {
  color: "text.secondary",
  ...textosGlobais.textoPadrao,
  fontSize: tamanhosControlesGlobais.descricao,
};

const TELA_COM_ALTURA_REDUZIDA =
  "@media (min-width: 900px) and (max-height: 740px)";

const RESUMOS_VISUAIS = [
  {
    titulo: "Superintendências cadastradas",
    descricao: "Regionais ativas no sistema.",
    Icone: BuildingsFillIcon,
    detalhes: ["Ativas", "Com cidades vinculadas"],
  },
  {
    titulo: "Cidades cadastradas",
    descricao: "Municípios disponíveis para gestão.",
    Icone: PlaceRoundedIcon,
    detalhes: ["Vinculadas a SREs", "Disponíveis para consulta"],
  },
  {
    titulo: "Catálogo de Ensino",
    descricao: "Etapas e modalidades do sistema.",
    Icone: MenuBookRoundedIcon,
    detalhes: ["Etapas", "Modalidades"],
  },
];

export default function PainelAdministrador() {
  const navigate = useNavigate();
  const reduzirMovimento = useReducedMotion();

  const atalhos = [
    {
      titulo: "Gerenciar SREs",
      descricao:
        "Cadastre, edite e gerencie as Superintendências Regionais de Ensino.",
      rota: "/admin/visualizar/sre",
      Icone: BuildingsFillIcon,
    },
    {
      titulo: "Gerenciar Cidades",
      descricao: "Cadastre, edite e gerencie as cidades vinculadas às SREs.",
      rota: "/admin/visualizar/cidade",
      Icone: PlaceRoundedIcon,
    },

    {
      titulo: "Catálogo de Ensino",
      descricao: "Organize as etapas, fases e modalidades das ofertas de ensino.",
      rota: "/admin/catalogo-ensino",
      Icone: MenuBookRoundedIcon,
    },
  ];

  return (
    <Box sx={{ width: "100%", py: 0 }}>
      {/* CABEÇALHO DO PAINEL */}
      <Box
        component={motion.div}
        {...obterTransicaoPaginaInicial("cabecalho", 0, reduzirMovimento)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.4,
          mb: espacamentosGlobais.secoes,
          [TELA_COM_ALTURA_REDUZIDA]: { mb: 1.5 },
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            display: "grid",
            placeItems: "center",
            flexShrink: 0,
            borderRadius: 1.5,
            color: "var(--sear-azul, #087cf0)",
            backgroundColor: "var(--sear-superficie-azul, #e8f4ff)",
          }}
        >
          <AdminPanelSettingsRoundedIcon sx={{ fontSize: 27 }} />
        </Box>

        <Box>
          <Typography
            component="h1"
            sx={{
              color: coresTextosGlobais.tituloPagina,
              ...textosGlobais.tituloPagina,
              fontSize: tamanhosPaginasAdministrativas.tituloPagina,
              lineHeight: 1.15,
            }}
          >
            Painel do Administrador
          </Typography>

          <Typography
            sx={{
              mt: 0,
              color: "var(--sear-texto-secundario, #7b8798)",
              ...textosGlobais.textoPadrao,
              fontSize: tamanhosControlesGlobais.descricao,
            }}
          >
            Acesse rapidamente as principais funcionalidades da administração do
            sistema.
          </Typography>
        </Box>
      </Box>

      {/* ATALHOS */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
          },
          gap: espacamentosGlobais.secoes,
        }}
      >
        {atalhos.map(({ titulo, descricao, rota, Icone }, indice) => (
          <Paper
            key={titulo}
            component={motion.div}
            {...obterTransicaoPaginaInicial("card", indice, reduzirMovimento)}
            sx={{
              p: 2,
              minWidth: 0,
              border: "1px solid var(--sear-borda, #c9def4)",
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              [TELA_COM_ALTURA_REDUZIDA]: { p: 1.5 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.4,
                flexGrow: 1,
              }}
            >
              <Box sx={ESTILO_CAIXA_ICONE}>
                <Icone sx={{ fontSize: iconesGlobais.secao.fontSize }} />
              </Box>

              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography component="h2" sx={ESTILO_TITULO_SECAO}>
                  {titulo}
                </Typography>

                <Typography
                  sx={{
                    ...ESTILO_DESCRICAO,
                    mt: espacamentosGlobais.tituloDescricao,
                    overflowWrap: "anywhere",
                  }}
                >
                  {descricao}
                </Typography>
              </Box>
            </Box>

            <Button
              fullWidth
              variant="contained"
              disabled={!rota}
              endIcon={rota ? <ArrowForwardRoundedIcon /> : <LockRoundedIcon />}
              onClick={rota ? () => navigate(rota) : undefined}
              sx={{
                textTransform: "none",
                fontSize: tamanhosControlesGlobais.botao,
                mt: espacamentosGlobais.descricaoCampos,
                [TELA_COM_ALTURA_REDUZIDA]: { mt: 1.5 },
                px: 4,
                backgroundColor: "var(--sear-acao-azul, #087cf0)",

                "&:hover": {
                  backgroundColor: "var(--sear-acao-azul-hover, #0767d8)",
                },

                "&.Mui-disabled": {
                  color: "var(--sear-texto-secundario, #4b719b)",
                  backgroundColor: "var(--sear-superficie-azul, #dceeff)",
                },

                "& .MuiButton-endIcon": {
                  position: "absolute",
                  right: 12,
                  margin: 0,
                },
              }}
            >
              {rota ? "Acessar" : "Em desenvolvimento"}
            </Button>
          </Paper>
        ))}
      </Box>

      {/* VISÃO GERAL: APENAS VISUAL, SEM CONSULTAS AO BACKEND */}
      <Paper
        component={motion.section}
        {...obterTransicaoPaginaInicial(
          "card",
          atalhos.length,
          reduzirMovimento,
        )}
        aria-labelledby="titulo-visao-geral-admin"
        aria-describedby="status-visao-geral-admin"
        elevation={0}
        sx={{
          mt: espacamentosGlobais.secoes,
          p: 2,
          border: "1px solid var(--sear-borda, #dcecff)",
          borderRadius: 2,
          backgroundColor: "var(--sear-superficie-azul, #e8f4ff)",
          [TELA_COM_ALTURA_REDUZIDA]: { mt: 1.5, p: 1.5 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.4,
            mb: espacamentosGlobais.descricaoCampos,
            [TELA_COM_ALTURA_REDUZIDA]: { mb: 1 },
          }}
        >
          <Typography
            id="titulo-visao-geral-admin"
            component="h2"
            sx={ESTILO_TITULO_SECAO}
          >
            Visão geral
          </Typography>

          <Box sx={{ flex: 1, height: 1, backgroundColor: "var(--sear-superficie-hover, #a8d0ff)" }} />
        </Box>

        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: 1.5,
          }}
        >
          {/* Os espaços reservados não representam dados do sistema. */}
          <Box
            aria-hidden="true"
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(3, minmax(0, 1fr))",
              },
              gap: espacamentosGlobais.secoes,
              opacity: 0.45,
              filter: "blur(1px)",
              pointerEvents: "none",
              userSelect: "none",
              // O fundo decorativo não define a altura em telas baixas.
              [TELA_COM_ALTURA_REDUZIDA]: { position: "absolute", inset: 0 },
            }}
          >
            {RESUMOS_VISUAIS.map(({ titulo, descricao, Icone, detalhes }) => (
              <Paper
                key={titulo}
                elevation={0}
                sx={{
                  p: 2,
                  minWidth: 0,
                  border: "1px solid var(--sear-borda, #dcecff)",
                  borderRadius: 1.5,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.4,
                  }}
                >
                  <Box sx={ESTILO_CAIXA_ICONE}>
                    <Icone sx={{ fontSize: iconesGlobais.secao.fontSize }} />
                  </Box>

                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        ...ESTILO_TITULO_SECAO,
                        overflowWrap: "anywhere",
                      }}
                    >
                      {titulo}
                    </Typography>

                    <Typography
                      sx={{
                        ...ESTILO_DESCRICAO,
                        mt: espacamentosGlobais.tituloDescricao,
                      }}
                    >
                      {descricao}
                    </Typography>
                  </Box>

                  <Typography
                    component="span"
                    sx={{
                      ...ESTILO_TITULO_SECAO,
                      px: 1.5,
                      borderRadius: 5,
                      backgroundColor: "var(--sear-superficie-azul, #e8f4ff)",
                      flexShrink: 0,
                    }}
                  >
                    —
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: espacamentosGlobais.descricaoCampos,
                    pt: 1,
                    borderTop: "1px solid var(--sear-borda, #e5edf5)",
                    display: "grid",
                    gap: espacamentosGlobais.tituloDescricao,
                  }}
                >
                  {detalhes.map((detalhe) => (
                    <Box
                      key={detalhe}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          flexShrink: 0,
                          borderRadius: "50%",
                          backgroundColor: "var(--sear-acao-azul, #087cf0)",
                        }}
                      />

                      <Typography sx={{ ...ESTILO_DESCRICAO, flex: 1 }}>
                        {detalhe}
                      </Typography>

                      <Typography sx={ESTILO_DESCRICAO}>—</Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            ))}
          </Box>

          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              backgroundColor: "var(--sear-superficie, rgba(255, 255, 255, 0.68))",
              [TELA_COM_ALTURA_REDUZIDA]: { position: "relative", p: 1.5 },
            }}
          >
            <Box
              id="status-visao-geral-admin"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.4,
                maxWidth: "100%",
                p: 2,
                border: "1px solid var(--sear-borda, #c9def4)",
                borderRadius: 2,
                backgroundColor: "var(--sear-superficie, #ffffff)",
                boxShadow: "0 4px 14px rgba(8, 124, 240, 0.08)",
                [TELA_COM_ALTURA_REDUZIDA]: { p: 1.5 },
              }}
            >
              <LockRoundedIcon
                sx={{
                  color: "var(--sear-azul, #087cf0)",
                  fontSize: iconesGlobais.secao.fontSize,
                  flexShrink: 0,
                }}
              />

              <Box>
                <Typography component="h3" sx={ESTILO_TITULO_SECAO}>
                  Em desenvolvimento
                </Typography>

                <Typography
                  sx={{
                    ...ESTILO_DESCRICAO,
                    mt: espacamentosGlobais.tituloDescricao,
                  }}
                >
                  Os indicadores serão disponibilizados em uma próxima
                  atualização.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
